import { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useFetchUserNotes from '../../hooks/notes/useFetchUserNotes';
import { setSelectedNoteAction } from '../../redux/actions/notesActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import PreviewNoteModal from './modals/PreviewNoteModal';
import NotesTable from './NotesTable';

const UserNotesList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, userNotes } = useFetchUserNotes();
  const [showPreviewNoteModal, setShowPreviewNoteModal] = useState(false);

  const handleNoteClick = (note) => {
    dispatch(setSelectedNoteAction(note));
    setShowPreviewNoteModal(true);
  };

  const handleNoteEditClick = (note) => {
    navigate(`/notes/${note.id}`);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showPreviewNoteModal && <PreviewNoteModal onModalClose={() => setShowPreviewNoteModal(false)} />}
        <NotesTable
          onNoteClick={handleNoteClick}
          onNoteEditClick={handleNoteEditClick}
          notes={userNotes}
          readOnly={readOnly}
          loading={loading}
          isPublic={false}
        />
        {userNotes.length === 0 && !loading && <EmptyContent title={'Список нотаток порожній'} />}
      </div>
    </Suspense>
  );
};

export default memo(UserNotesList);
